import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './Loader.module.scss';

interface ILoaderProps {
  size?: number;
  className?: any;
}

const Loader: FC<ILoaderProps> = ({ size, className }) => {
  return (
    <div className={className || styles.wrapper}>
      <CircularProgress size={size} />
    </div>
  );
};

export default Loader;
